<template>
  <div class="sitemap-wrap">
    <div class="sitemap-wrap-container" v-for="(list, index) in lists" :key="index">
      <div class="sitemap-title">
        {{ list.title }}
      </div>
      <div class="sitemap-link">
        <a :href="link.link" v-for="(link, index) in list.links" :key="index" :target="link.target">
          {{ link.text }}
        </a>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      lists: [
        {
          title: this.$t('main.DRAWER_MIDLAND_ICS'),
          links: [
            {
              link: `https://www.legendupstarholdings.com/${
                this.$i18n.locale === 'en' ? 'eng' : 'chi'
              }`,
              text: this.$t('main.CORP'),
              target: '_blank',
            },
            {
              link: '/ics/property/company',
              text: this.$t('main.GROUP_MEMBERS'),
              target: '_blank',
            },
            {
              link: '/ics/property/branch',
              text: this.$t('main.BRANCH_NETWORK'),
            },
            {
              link: '/ics/property/site_map',
              text: this.$t('main.SITEMAP'),
            },
            {
              link: '/ics/property/recruitment',
              text: this.$t('main.RECURITMENT'),
            },
            {
              link: '/ics/property/member',
              text: this.$t('main.MEMBERSHIP'),
            },
            {
              link: '/ics/property/partner',
              text: this.$t('main.BE_PARTNER'),
            },
          ],
        },
        {
          title: this.$t('main.STOCKS'),
          links: [
            {
              link: '/ics/property/find',
              text: this.$t('main.ALL_STOCKS'),
            },
            {
              link: '/ics/property/find/industrial',
              text: this.$t('main.STOCK_I'),
            },
            {
              link: '/ics/property/find/office',
              text: this.$t('main.STOCK_C'),
            },
            {
              link: '/ics/property/find/shops',
              text: this.$t('main.STOCK_S'),
            },
            {
              link: '/ics/property/firsthand',
              text: this.$t('main.FIRST_HAND_STOCK'),
            },
            {
              link: '/ics/property/find/?non_new_property=1',
              text: this.$t('main.DRAWER_SOLE_AGENT'),
            },
            {
              link: '/ics/property/tender',
              text: this.$t('main.TENDER'),
            },
            {
              link: '/ics/property/building',
              text: this.$t('main.BLDG_PAGE_SH'),
            },
          ],
        },
        {
          title: this.$t('main.CUSTOMER_SUPPORT'),
          links: [
            {
              link: '/ics/property/contactus/easy_i',
              text: this.$t('main.PROPERTY_LISTING'),
            },
            {
              link: '/ics/property/agent',
              text: this.$t('main.PRO_AGENTS'),
            },
            {
              link: '/ics/property/mitaclub',
              text: this.$t('main.MITACLUB'),
            },
            {
              link: '/ics/property/contactus',
              text: this.$t('main.DRAWER_INQUIRE'),
            },
            {
              link: 'tel://+85265338082',
              text: this.$t('main.DRAWER_CONTACT_US'),
            },
            {
              link: '/ics/property/calculator',
              text: this.$t('main.DRAWER_CALCULATOR'),
            },
            {
              link: '/ics/property/payment_method',
              text: this.$t('main.PAYMENT_METHOD'),
            },
          ],
        },
        {
          title: this.$t('main.TX_DATA'),
          links: [
            {
              link: '/ics/property/transaction',
              text: this.$t('main.LATEST_TX'),
            },
            {
              link: '/ics/property/research',
              text: this.$t('main.DRAWER_RESEARCH_DEPT'),
            },
          ],
        },
        {
          title: this.$t('main.DRAWER_INFO'),
          links: [
            {
              link: '/ics/property/video',
              text: this.$t('main.DRAWER_VIDEOS'),
            },
            {
              link: '/ics/property/dailynews',
              text: this.$t('main.DRAWER_NEWS_COMMON'),
            },
            {
              link: '/ics/property/ics_guide',
              text: this.$t('main.DRAWER_ICS_GUIDE'),
            },
            {
              link: '/ics/property/columns',
              text: this.$t('main.DRAWER_DANIEL_BLOG'),
            },
            {
              link: '/ics/property/news',
              text: this.$t('main.DRAWER_NEWS'),
            },
            {
              link: '/ics/property/shops_map',
              text: this.$t('main.DRAWER_SHOPS_MAP'),
            },
            {
              link: '/ics/property/walk_street_guide',
              text: this.$t('main.DRAWER_WALK_STREET_GUIDE'),
            },
          ],
        },
      ],
    };
  },
};
</script>
<style scoped>
.sitemap-link {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.sitemap-title {
  color: #2d2d2d;
  font-weight: 700;
  font-size: 18px;
  margin-bottom: 13px;
}

.sitemap-link a {
  color: #2d2d2d;
}

.sitemap-wrap {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  column-gap: 24px;
  padding: 64px 0 48px;
}

.sitemap-wrap-container {
  flex-basis: 158px;
}

/* mobile */
@media (max-width: 991px) {
  .sitemap-wrap {
    display: none;
  }
}
</style>
